import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="bg-background-900 border-t border-background-700/30">
      <div className="px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link
              to="/"
              className="flex items-center gap-2 mb-4 whitespace-nowrap cursor-pointer"
            >
              <span className="w-8 h-8 flex items-center justify-center">
                <i className="ri-ancient-gate-line text-primary-500 text-2xl"></i>
              </span>
              <span className="text-lg font-bold font-heading text-foreground-100">
                风车动漫
              </span>
            </Link>
            <p className="text-sm text-foreground-500 leading-relaxed">
              海量动漫，在线观看。风车动漫拥有庞大动漫库，提供数千部作品在线观看，覆盖多样类型和年代。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link
                  to="/"
                  className="text-sm text-foreground-500 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors"
                >
                  首页
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm text-foreground-500 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors"
                >
                  关于我们
                </Link>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-500 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors"
                >
                  使用帮助
                </a>
              </li>
              <li>
                <a
                  href="#"
                  className="text-sm text-foreground-500 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors"
                >
                  意见反馈
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              动漫分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 4).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-500 hover:text-primary-400 whitespace-nowrap cursor-pointer transition-colors"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/category/action"
                  className="text-sm text-primary-400 hover:text-primary-300 whitespace-nowrap cursor-pointer transition-colors"
                >
                  查看全部分类 &rarr;
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-foreground-200 mb-4">
              关注我们
            </h4>
            <div className="flex gap-3 mb-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer"
                aria-label="哔哩哔哩"
                rel="nofollow"
              >
                <i className="ri-bilibili-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-full bg-background-800 text-foreground-500 hover:text-primary-400 hover:bg-background-700 transition-colors cursor-pointer"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line"></i>
              </a>
            </div>
            <p className="text-sm text-foreground-500">
              联系邮箱：contact@fengchedongman.com
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-700/30 py-6">
        <div className="px-4 md:px-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-600">
            &copy; 2024 风车动漫 FengCheDongMan. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a
              href="#"
              className="text-xs text-foreground-600 hover:text-foreground-400 whitespace-nowrap cursor-pointer transition-colors"
            >
              隐私政策
            </a>
            <a
              href="#"
              className="text-xs text-foreground-600 hover:text-foreground-400 whitespace-nowrap cursor-pointer transition-colors"
            >
              服务条款
            </a>
            <a
              href="#"
              className="text-xs text-foreground-600 hover:text-foreground-400 whitespace-nowrap cursor-pointer transition-colors"
            >
              版权声明
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}